angular.module("vgresiduos").factory("residuesManagementService", [
	"$http",
	"accountService",
	function ($http, accountService) {
		"use strict";
		const _listDisposalsForFollowup = function (params) {
			const organizationId = accountService.getCurrentClient().organization.id;
			let parameters = "";
			if (params) {
				parameters = $.param(params);
			}

			const req = {
				method: "get",
				url:
					Vgr.constants.residuesManagementHostUrl +
					Vgr.resources.residuesManagement.disposalsForFollowup
						.replace("[ORGANIZATION_UNIT]", accountService.getCurrentClient().code)
						.replace("[ORGANIZATION_ID]", organizationId) +
					"?" +
					parameters
			};
			return $http(req);
		};

		return {
			listDisposalsForFollowup: _listDisposalsForFollowup
		};
	}
]);
